module.exports = __webpack_public_path__ + "img/神经网络计算-中层.1b4ab282.png";